const categories = [
    {
        category: 'All',
        redirect: '/'
    },
    {
        category: 'Sports',
        redirect: '/sport'
    },
    {
        category: 'Culture',
        redirect: '/culture'
    },
    {
        category: 'Opinion',
        redirect: '/commentisfree'
    },
    {
        category: 'Lifestyle',
        redirect: '/lifeandstyle'
    },
    {
        category: 'Science',
        redirect: '/science'
    },
    {
        category: 'Technology',
        redirect: '/technology'
    }
];

export default categories;
